/* eslint-disable @typescript-eslint/no-explicit-any */

import Vue from "vue";
import VueI18n from 'vue-i18n';
import Vuex from "vuex";
import VueRouter, { RouteConfig as _RouteConfig } from 'vue-router'
import { AxiosResponse } from 'axios';
import { State, FromStore } from "./vuex-support";
import {
    AbacoVuexModule,
    AbacoWebModule as _AbacoWebModule,
    ApplicationConfig as _ApplicationConfig,
    MenuItem as _MenuItem,
    Application,
    ApplicationReadyEvent as _ApplicationReadyEvent,
    RouterReadyEvent as _RouterReadyEvent,
    VueRegistration as _VueRegistration,
    SetI18nVariantFunction as _SetI18nVariantFunction,
} from "./Application";
import Toast, {ToastOptions as _ToastOptions} from "./Toasted";

import "@abaco/abc-icons/index.css"

export type VueRegistration = _VueRegistration;
export type ApplicationReadyEvent = _ApplicationReadyEvent;
export type RouterReadyEvent = _RouterReadyEvent;
export type AbacoWebModule = _AbacoWebModule;
export type MenuItem = _MenuItem;
export type ApplicationConfig = _ApplicationConfig;
export type RouteConfig = _RouteConfig;
export type ToastOptions = _ToastOptions;
export type SetI18nVariantFunction = _SetI18nVariantFunction

Vue.config.productionTip = false;

export {
    AbacoVuexModule,
    Application,
    AxiosResponse,
    FromStore,
    State,
    VueRouter,
    Vue,
    VueI18n,
    Vuex,
    Toast
};


